import React from 'react'

import ErrorPage from 'pages/DefaultErrorPage/DefaultErrorPage'

import { navigateToUrl } from 'single-spa'
import Mark from 'assets/mark.svg'

const ConnFailed = () => {
  return (
    <ErrorPage
      img={{
        src: Mark,
        alt: 'Aviso',
      }}
      action="Falha de conexão"
      body="Parece que algo atrapalhou minha conexão. Por favor, verifique seu acesso a internet para continuar ou tente mais tarde."
      button={{
        text: 'Ir para a página principal',
        onClick: () => navigateToUrl('/'),
      }}
    />
  )
}

export default ConnFailed
